import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Card, Image } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetStoreSupplyDetailsQuery } from '../slices/storeSuppliesApiSlice';
import StoreSupplyCarousel from '../components/StoreSupplyCarousel';

const StoreSupplyScreen = () => {
  const { id: storeSupplyId } = useParams();

  const { data: storeSupply, refetch, isLoading, error } = useGetStoreSupplyDetailsQuery(storeSupplyId);

  useEffect(() => {
    if (!storeSupply) {
      refetch();
    }
  }, [storeSupply, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>StoreSupply {storeSupply._id}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Supplier Details</h2>
              <p>
                <strong>Name: </strong> {storeSupply.supplierDetails.name}
              </p>
              <p>
                <strong>Company: </strong> {storeSupply.supplierDetails.company}
              </p>
              <p>
                <strong>Phone: </strong> {storeSupply.supplierDetails.telephone}
              </p>
              <p>
                <strong>Address: </strong> {storeSupply.supplierDetails.address}
              </p>
              <p>
                <strong>Serial: </strong> {storeSupply.supplierDetails.serialNumber}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>StoreSupply Note</h2>
              <p>{storeSupply.note || 'No additional notes provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>StoreSupply Items</h2>
              {storeSupply.storeSupplyItems.length === 0 ? (
                <Message>This storeSupply has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {storeSupply.storeSupplyItems.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item.images}
                            alt={item.name}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item.name}</strong>
                        </Col>
                        <Col md={4}>
                          {item.qty} x ${item.price} = D{item.qty * item.price}
                        </Col>
                        <Col md={2}>
                          <strong>Cost: </strong>D{item.itemCost}
                        </Col>
                        <Col md={2}>
                          <strong>Profit: </strong>D{item.profit}
                        </Col>

                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>StoreSupply Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{storeSupply.date.substring(0, 10)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Expiry Date</Col>
                  <Col>{storeSupply.expiryDate.substring(0, 10)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total Cost</Col>
                  <Col>D{storeSupply.cardCost}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{storeSupply.status}</Col>
                  <Col>{storeSupply?.username || 'No user name provided'}</Col>
                  <Col md={6}>
                            {/* Display expense images using StoreSupplyCarousel */}
                            {storeSupply.images && storeSupply.images.length > 0 ? (
                              <StoreSupplyCarousel images={storeSupply.images} />
                            ) : (
                              <Message variant="info">No images available for this expense</Message>
                            )}
                   </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default StoreSupplyScreen;